<template>
  <div class="zero-results">
    <div class="tw-mb-10">
      <div class="zero-results__image tw-w-52">
        <slot></slot>
      </div>
    </div>
    <div class="zero-results__message-container">
      <h2 class="zero-results__heading-message" data-test-id="page-heading">
        <span v-html="headingMessage"></span>
      </h2>
      <h3 class="zero-results__secondary-message">
        <span v-html="secondaryMessage"></span>
      </h3>
    </div>
    <AcvButton
      v-if="action.length"
      :outlined="true"
      @click.stop="emit('actionClicked')"
      class="zero-results__button"
      data-test-id="error-cta"
    >
      {{ action }}
    </AcvButton>
  </div>
</template>

<script setup>
const props = defineProps({
  headingMessage: {
    type: String,
    default: "We didn't find any exact matches",
  },
  secondaryMessage: {
    type: String,
    default:
      'Jobs are constantly being added to our Loadboard.  Change filters and search again!',
  },
  action: {
    type: String,
    default: 'Clear All Filters',
  },
});

const emit = defineEmits(['actionClicked']);
</script>

<style lang="scss" scoped>
@use '@/assets/scss/search/buttons.scss';
.zero-results {
  @apply tw-text-text-secondary
  tw-text-center
  tw-p-4
  tw-flex
  tw-items-center
  tw-justify-center
  tw-flex-col
  tw-h-svh;
}
.zero-results__image {
  max-width: 200px;
  max-height: 200px;
}

.zero-results__message-container {
  max-width: 375px;
}
.zero-results__heading-message {
  @apply tw-mb-2
  tw-font-medium
  tw-text-xl;
}
.zero-results__secondary-message {
  @apply tw-text-base
  tw-font-regular
  tw-mb-7;
}
.zero-results__button {
  min-width: 201px;
}
</style>
